module.exports = __webpack_public_path__ + "static/media/handshake.e24f90ec.png";